module.exports = __webpack_public_path__ + "img/vertical_7_2_7016.c9e6d875.png";